import { render, staticRenderFns } from "./ClientCardViewer.vue?vue&type=template&id=1074c6ec"
import script from "./ClientCardViewer.vue?vue&type=script&lang=js"
export * from "./ClientCardViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports